/* Pearl and Post Atelier: verwachte leverdatum (OPDRACHT-4 6.1, agent cadeau, 20 okt 2026).
   Zelfde regels als tools/leverdatum.py (referentie) en snippets/pp-delivery-estimate.liquid:
   7 tot 12 working days, maandag tot en met vrijdag, UK bank holidays overgeslagen; besteld voor 14:00 UK-tijd op een
   werkdag = dag 0, anders de volgende werkdag. Klok altijd Europe/London via Intl, nooit de lokale klok van de bezoeker.
   Klok: PPSeason.now() van motor (assets/pp-season.js; ?pp_date= alleen op een niet-live thema), anders zelf met Intl.
   Na de besteldag zet het in [data-pp-xmas-after] (snippets/pp-season-xmas, motor) de juiste zin. */
(function (root) {
  'use strict';
  var DAG = 864e5;
  var DAGEN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MAANDEN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function iso(d) { return d.toISOString().slice(0, 10); }
  function datum(s) { var p = s.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])); }
  function werkdag(d, f) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !f[iso(d)]; }
  function volgende(d, f) { var n = new Date(d.getTime() + DAG); while (!werkdag(n, f)) { n = new Date(n.getTime() + DAG); } return n; }
  function plus(d, n, f) { for (var i = 0; i < n; i++) { d = volgende(d, f); } return d; }
  function set(lijst) { var f = {}; (lijst || []).forEach(function (s) { if (/^\d{4}-\d{2}-\d{2}$/.test(s)) { f[s] = 1; } }); return f; }

  /* tijd: 'YYYY-MM-DDTHH:MM[:SS]' in Europe/London */
  function bereken(tijd, feestdagen, cfg) {
    cfg = cfg || {};
    var cut = cfg.cut === undefined ? 1400 : cfg.cut, min = cfg.min || 7, max = cfg.max || 12;
    var f = set(feestdagen);
    var dag = datum(tijd.slice(0, 10));
    var hhmm = parseInt(tijd.slice(11, 13) + tijd.slice(14, 16), 10) || 0;
    var start = (werkdag(dag, f) && hhmm < cut) ? dag : volgende(dag, f);
    return { start: iso(start), vroegst: iso(plus(start, min, f)), uiterst: iso(plus(start, max, f)) };
  }

  function tekst(s) { var d = datum(s); return DAGEN[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MAANDEN[d.getUTCMonth()]; }

  function regel(u) { return 'Estimated delivery: ' + tekst(u.vroegst) + ' to ' + tekst(u.uiterst); }

  /* Regel na de besteldag (Q4-1): uiterste leverdatum voor de grens (24 dec) = vroeg, anders laat. */
  function naTekst(u, limiet, vroeg, laat) { return u.uiterst < limiet ? vroeg : laat; }

  function nuLondon(d) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(d || new Date()).forEach(function (x) { p[x.type] = x.value; });
    var uur = p.hour === '24' ? '00' : p.hour;
    return p.year + '-' + p.month + '-' + p.day + 'T' + uur + ':' + p.minute + ':' + p.second;
  }

  function nu() {
    var rol = root.Shopify && root.Shopify.theme && root.Shopify.theme.role;
    if (root.PPSeason && typeof root.PPSeason.now === 'function') {
      try { var m = root.PPSeason.now(); if (typeof m === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(m)) { return m; } } catch (e) { /* eigen klok */ }
    }
    if (rol && rol !== 'main' && root.location) {
      var q = new URLSearchParams(root.location.search).get('pp_date');
      if (q && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(q)) { return q.length === 16 ? q + ':00' : q; }
    }
    return nuLondon();
  }

  function verwerk(scope) {
    var t = nu();
    var els = (scope || document).querySelectorAll('[data-pp-delivery]');
    if (!els.length) { return; }
    Array.prototype.forEach.call(els, function (el) {
      var cfg;
      try { cfg = JSON.parse(el.getAttribute('data-pp-delivery') || '{}'); } catch (e) { return; }
      var u = bereken(t, cfg.fd, cfg);
      var r = el.querySelector('[data-pp-delivery-tekst]');
      if (r && cfg.toon !== false) { var nieuw = regel(u); if (r.textContent !== nieuw) { r.textContent = nieuw; } }
      Array.prototype.forEach.call(el.querySelectorAll('[data-pp-xmas-after]'), function (k) {
        var z = naTekst(u, k.getAttribute('data-limit') || '2026-12-24', k.getAttribute('data-early') || '', k.getAttribute('data-late') || '');
        if (z && k.textContent !== z) { k.textContent = z; }
      });
      el.setAttribute('data-pp-delivery-nu', t);
    });
  }

  var api = { bereken: bereken, tekst: tekst, regel: regel, naTekst: naTekst, nuLondon: nuLondon, nu: nu, verwerk: verwerk };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (root.PPDelivery) { root.PPDelivery.verwerk(); return; }
  root.PPDelivery = api;
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { verwerk(); }); } else { verwerk(); }
  document.addEventListener('theme:cart:change', function () { setTimeout(verwerk, 0); });
  document.addEventListener('pp:season', function () { setTimeout(verwerk, 0); });
  root.addEventListener('pageshow', function (e) { if (e.persisted) { verwerk(); } });
})(typeof window !== 'undefined' ? window : this);
